import { call, put, takeLatest } from 'redux-saga/effects';
import type { Poster } from '@nx/domain';
import { posterRepository } from '../../services/eoRepositories';
import { pushToast } from '../slices/eoUiSlice';
import {
  posterFailed,
  posterLoaded,
  posterLoadRequested,
  posterSaveSucceeded,
  posterUpsertRequested,
} from '../slices/posterSlice';

function* handleLoad(action: ReturnType<typeof posterLoadRequested>): Generator<unknown, void, unknown> {
  try {
    const poster = (yield call([posterRepository, posterRepository.getByEvent], action.payload)) as Poster | null;
    yield put(posterLoaded(poster));
  } catch (e) {
    yield put(posterFailed(e instanceof Error ? e.message : 'Failed'));
  }
}

function* handleUpsert(action: ReturnType<typeof posterUpsertRequested>): Generator<unknown, void, unknown> {
  try {
    const poster = (yield call(
      [posterRepository, posterRepository.upsert],
      action.payload.eventId,
      action.payload.input,
    )) as Poster;
    yield put(posterSaveSucceeded(poster));
    yield put(pushToast({ msg: 'eo.toast.posterSaved', kind: 'success' }));
  } catch (e) {
    yield put(posterFailed(e instanceof Error ? e.message : 'Failed'));
    yield put(pushToast({ msg: 'eo.toast.posterSaveFailed', kind: 'danger' }));
  }
}

export function* posterSaga() {
  yield takeLatest(posterLoadRequested.type, handleLoad);
  yield takeLatest(posterUpsertRequested.type, handleUpsert);
}
